import { UI_ContentCard } from 'ui/components/2-molecules/Card/ContentCard/ContentCard';

interface Props {
	content: {
		properties: {
			kicker: string;
			altText: string;
			heading: string;
			text: string;
			link: Content.Link | null;
			image: Content.Image | null;
		};
	};
	settings: {
		properties: {
			displayLinkAsButton: boolean;
			orientation: Content.Orientation;
			imageCropping: Content.ImageCropping;
		};
	};
}

export const ContentCard = ({ settings, content }: Props) => {
	const { displayLinkAsButton, orientation, imageCropping } = settings?.properties ?? {};

	return (
		<UI_ContentCard
			{...content?.properties}
			displayLinkAs={displayLinkAsButton ? 'button' : null}
			orientation={orientation}
			imageCropping={imageCropping}
			image={
				content?.properties?.image
					? {
							url: content.properties.image.url,
							focalPoint: content.properties.image.focalPoint,
							extension: content.properties.image.extension,
						}
					: null
			}
		/>
	);
};
